var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{staticClass:"content__header-logo",attrs:{"src":require("@/assets/images/logo.png"),"alt":_vm.appName,"width":"180"}})])}
var staticRenderFns = []

export { render, staticRenderFns }